import { CustomTabPanel } from "@/erp/sale";
import { sizeTab, a11yProps, ROUTER_PATHS } from "@/shared";
import { SingleTableBoxScene } from "@/shared/components/ui";
import { Box, Tabs, Tab } from "@mui/material";
import { useState } from "react";
import TableBras from "../../shared/component/table_bras/TableBras";

export default function BrasPage() {

  const [valueTab, setValueTab] = useState(0);

  return (
    <SingleTableBoxScene
      title={"Bras"}
      py={2}

      enableRedirect={true}
      urlRedirect={ROUTER_PATHS.configuracionRED.brasCrearNav}
    >
      <Box sx={{ bgcolor: 'background.paper', maxWidth: sizeTab, paddingBottom: 2 }} >
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Tabs
            value={valueTab}
            onChange={(_event: React.SyntheticEvent, newValue: number) => {
              setValueTab(newValue);
            }}
            variant="scrollable"
            scrollButtons="auto"
            allowScrollButtonsMobile
            aria-label="scrollable force tabs bras"
          >
            <Tab label={'Activos'} {...a11yProps(0)} />
          </Tabs>

        </Box>
      </Box>

      <CustomTabPanel value={valueTab} index={0}>
        <TableBras />
      </CustomTabPanel>

    </SingleTableBoxScene>
  )

}